import { render } from "./rentalList.vue?vue&type=template&id=44880c0e"
import script from "./rentalList.vue?vue&type=script&lang=js"
export * from "./rentalList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__